module.exports = __webpack_public_path__ + "img/2_55.975a2c0c.png";